import { FileEntity } from '@flicent/fieldpulse-react-component-library-frontend';

import { ApiServiceInstance } from './Api.service';


interface RequestParams {
  token: string;
  formId: number;
}

interface ResponseDataType {
  files: FileEntity[];
}

export const getCustomFormFilesRequest = ({
                                            token,
                                            formId,
                                          }: RequestParams): Promise<ResponseDataType> => {

  return ApiServiceInstance.makeRequest(`/custom-form/${ formId }/get-files`, {
    token,
  });
};